import React, { Component } from "react"

/* Constants */
import { env } from "../constants"

/* Components */
import { Picture, Card } from "@cuba-go/poker-ui"

/* Fields */
const ADDITIONAL_PLACES = ['1', '2', '3', '4', '5']

/* Widget Additional Cards */
class AdditionalCards extends Component {

    /* Filter Cards By Unqiue ID */
    getUniqueValues = (array, prop) => {
        return array.filter((element, index, self) =>
            index === self.findIndex(item =>
                item[prop] === element[prop]
            )
        )
    }

    /* Draw card image */
    _image = (card) => {

        if (card) {
            return <Card data={card.name} />
        }

        return <Card closed={true}/>
    }


    /* Draw flip animation box */
    _flip = (card, index) => {

        return (
            <div className={`ump--additional-flip-card active`}>
                <div className="ump--additional-flip-card-inner">
                    <div className="ump--additional-flip-card-front">
                        <Card closed={true}/>
                    </div>
                    <div className="ump--additional-flip-card-back">
                        {this._image(card, index)}
                    </div>
                </div>
            </div>
        )
    }

    /* Draw card */
    _card = () => {

        const cards = this.getUniqueValues(this.props.cards, 'id')

        return (
            <div className="ump--additional-box">

                <div className="ump--additional-cards">
                    {cards.map((card, index) => (
                        <div className={`ump--additional-card`} key={`${card.id}`}>
                            {this._flip(card, index)}
                        </div>
                    ))}
                </div>

                <div className="ump--additional-cards-places">
                    {ADDITIONAL_PLACES.map(item => <div key={`place-${item}`} className={`ump--additional-card-place`}></div>)}
                </div>

            </div>
        )
    }

    render = () => {

        const { style } = this.props

        return (
            <div className={`ump--additional ${style}`}>
                <h2>Дополнительные карты</h2>
                {this._card()}
            </div>
        )

    }

}

export default AdditionalCards